import gsap from 'imports/gsap'
let slides = {
    init: function () {
        slides.swiper = new Swiper(".mySwiper", {
            slidesPerView: 3.5,
            spaceBetween: 50,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                1200: {
                    slidesPerView: 3.5,
                    spaceBetween: 40,
                    centeredSlides: false
                },
                800: {
                    slidesPerView: 2.5,
                    spaceBetween: 40,
                    centeredSlides: false
                },
                500: {
                    slidesPerView: 1.4,
                    spaceBetween: 30,
                    centeredSlides: true,
                }
            }
        });
    }
}
export default slides
